import { SelectListDto } from '@sib/api';

export type SelectOption = {
  label: string;
  value: string;
};

export const mapEntityToSelectOption = (item: {
  id: string;
  name: string;
}): SelectOption => ({
  label: item.name,
  value: item.id,
});

export const mapSelectListToOptions = (data: SelectListDto): SelectOption[] =>
  data.items.map(mapEntityToSelectOption);
